// extracted by mini-css-extract-plugin
export default {"token":"ParkingTokenItem_token__lvrne"};